<template>
  <div>
    <!-- 通知 -->
    <el-dialog :title="$t('message.notice')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1080px"
      center>
      <div class="content">
        <el-tabs v-model="hasRead" type="card" @tab-click="adminNoticeList">
          <!-- 未读 -->
          <el-tab-pane :label="$t('message.unread')" name="1"></el-tab-pane>
          <!-- 已读 -->
          <el-tab-pane :label="$t('message.read')" name="2"></el-tab-pane>
        </el-tabs>
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!-- 标题 -->
            <li>
              {{ $t("message.title") }}
            </li>
            <!-- 内容 -->
            <li class="flex15">
              {{ $t("message.content") }}
            </li>
            <!-- 发送日期 -->
            <li>
              {{ $t("message.sendTime") }}
            </li>
            <!-- 操作 -->
            <!-- <li class="flex05">
              {{ $t("message.operation") }}
            </li> -->
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!-- 选择 -->
            <li class="flex05">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </li>
            <!-- 标题 -->
            <li>
              {{ item.title }}
            </li>
            <!-- 内容 -->
            <li class="flex15">
              <div v-html="item.content"></div>
            </li>
            <!-- 发送日期 -->
            <li>
              {{ item.created_at }}
            </li>
            <!-- 操作 -->
            <!-- <li class="flex05">
              <el-button size="mini" type="primary" class="dark" @click="batchDelete(item.id)">{{ $t('message.delete') }}</el-button>
            </li> -->
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="batchDelete" type="primary" class="dark">{{ $t('message.delete') }}</el-button>
        <!-- 已读 -->
        <el-button type="primary" @click="save" v-if="hasRead == 1">{{
          $t("message.read")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      list: [],
      dialogVisible: false,
      hasRead: '1'
    };
  },
  methods: {
    adminNoticeList() {
      let datas = {
        hasRead: this.hasRead,
        pageSize: 99999
      }
      this.$api.siteConfiguration.adminNoticeList(datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = true
        })
        this.list = res.data.data
        console.log(res);
      })
    },
    // 保存
    save() {
      let datas = {
        ids: []
      }
      this.list.forEach(item => {
        if (item.checked) {
          datas.ids.push(item.id)
        }
      })
      datas.ids.forEach((item, index) => {
        this.$api.siteConfiguration
          .readNotice({ id: item })
          .then((res) => {
            if (datas.ids.length - 1 == index) {
              this.$message.success(res.msg);
              this.adminNoticeList();
              this.$parent.unreadNotice()
            }
          });
      })

    },
    //删除
    batchDelete() {
      let datas = {
        ids: []
      }
      this.list.forEach(item => {
        if (item.checked) {
          datas.ids.push(item.id)
        }
      })
      this.$confirm(this.$t("message.whetherToDeleteTheSelectedOrder"), this.$t("message.prompt"), {
        confirmButtonText: this.$t("message.save"),
        cancelButtonText: this.$t("message.cancel"),
        type: "warning",
        center: true,
      })
        .then(() => {
          // 修改推荐商品
          this.$api.siteConfiguration
            .batchDelete(datas)
            .then((res) => {
              this.$message.success(res.msg);
              this.adminNoticeList();
            });
        })
        .catch(() => { });
    },

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.hasRead = '1'
        this.adminNoticeList()
      }
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow-y: auto;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }


      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }
  }


}
</style>